import { Box, Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { userQuery } from '../../../core/authentication/queries';
import { organizationQuery } from '../../../core/organization/queries';
import { selectedSessionsQuery, sessionsQuery } from '../../../core/sessions/queries';
import { useAppSelector } from '../../../types';
import { formatDistance } from '../../../utils/numbers';
import { theme } from '../../legacy/style/theme';
import { ActionsOnSelectedSessions } from './ActionsOnSelectedSessions';
import { OrganizationName, SessionUsername, Title } from './styles';
import { Header } from '../../design_system/page/Header';

export const SessionHeader = () => {
    const { t } = useTranslation();
    const sessionList = useSelector(sessionsQuery);
    const selectedSessions = useSelector(selectedSessionsQuery);
    const organization = useAppSelector(organizationQuery);
    const user = useAppSelector(userQuery);

    const { count, totalDistance } = useMemo(() => {
        const meters = selectedSessions.reduce((sum, { metadata }) => sum + metadata.cumulativeEnd, 0);

        return { count: selectedSessions.length, totalDistance: formatDistance(meters) };
    }, [selectedSessions]);

    return (
        <>
            <Grid container>
                <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100px' }} xs={3}>
                    <Title>{t('session.yourSessions')}</Title>
                    {sessionList && count > 0 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', mt: '-24px' }}>
                            <Typography sx={{ color: theme.color.blue.primary3, fontSize: '18px', fontWeight: 600 }}>
                                {t('session.selectedSessions', { count })}
                            </Typography>
                            <Typography sx={{ color: theme.color.blue.primary3, fontSize: '14px', fontWeight: 500 }}>
                                {t('session.totalDistance', { totalDistance })}
                            </Typography>
                        </Box>
                    )}
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Header />
                </Grid>
                <Grid
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                        mt: '24px',
                        paddingRight: '6px',
                    }}
                    xs={3}
                >
                    <SessionUsername>
                        {user?.lastName} {user?.firstName}
                    </SessionUsername>
                    <OrganizationName>{organization?.name}</OrganizationName>
                </Grid>
            </Grid>
            <ActionsOnSelectedSessions />
        </>
    );
};
